import React, { useState } from 'react';

import './styles.scss';
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import threeDotsIcon from '../../assets/three-dots-icon.svg';

const DropdownThreeDots = ({ options }) => {
  const [isOpen, setOpen] = useState(false);

  return (
    <ButtonDropdown className="styled-dropdown-button" isOpen={isOpen} toggle={() => setOpen(!isOpen)} direction="left">
      <DropdownToggle className="styled-toggle">
        <img src={threeDotsIcon} alt="three-dots" />
      </DropdownToggle>
      <DropdownMenu className="dropdown-menu-wrapper">
        {options.map(option => (
          <DropdownItem className="styled-menu-option" key={option.label} onClick={option.method}>
            {option.label}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </ButtonDropdown>
  );
};

export default DropdownThreeDots;
